"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactIntersectionObserver = require("react-intersection-observer");

var _uiKit = require("@dbi-tools/ui-kit");

var _const = require("../../../const");

var _useStyles = require("../../../hooks/useStyles");

var _heroSlide = require("../hero-slide.styled");

var _heroSlideA = _interopRequireDefault(require("./hero-slide-a"));

var _heroSlideB = _interopRequireDefault(require("./hero-slide-b"));

var _heroSlideC = _interopRequireDefault(require("./hero-slide-c"));

var _heroSlideD = _interopRequireDefault(require("./hero-slide-d"));

var _heroSlide2 = require("./hero-slide.styled");

var _style = _interopRequireDefault(require("./style"));

var _types = require("./types");

var _heroSlideType;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var heroSlideType = (_heroSlideType = {}, _defineProperty(_heroSlideType, _types.HeroSlideTypeName.TYPE_A, _heroSlideA.default), _defineProperty(_heroSlideType, _types.HeroSlideTypeName.TYPE_B, _heroSlideB.default), _defineProperty(_heroSlideType, _types.HeroSlideTypeName.TYPE_C, _heroSlideC.default), _defineProperty(_heroSlideType, _types.HeroSlideTypeName.TYPE_D, _heroSlideD.default), _heroSlideType);

var HeroSlideUi = function HeroSlideUi(_ref) {
  var _ref$type = _ref.type,
      type = _ref$type === void 0 ? _types.HeroSlideTypeName.TYPE_A : _ref$type,
      bgImages = _ref.bgImages,
      $color = _ref.textColor,
      $align = _ref.textAlign,
      rest = _objectWithoutProperties(_ref, ["type", "bgImages", "textColor", "textAlign"]);

  var _useInView = (0, _reactIntersectionObserver.useInView)({
    triggerOnce: true
  }),
      inView = _useInView.inView,
      ref = _useInView.ref;

  var bgImagesStyles = (0, _heroSlide.responsiveStyles)({
    items: bgImages
  });
  var Slide = heroSlideType[type];
  var bgStyles = inView ? bgImagesStyles : "";
  var typeLetter = type[type.length - 1];
  var heroSlideProps = {
    styles: bgStyles,
    $color: $color,
    $align: $align
  };
  var styles = (0, _useStyles.useStyles)(typeLetter, _style.default);
  return /*#__PURE__*/_react.default.createElement(_uiKit.ThemeProvider, {
    theme: {
      styles: styles
    }
  }, /*#__PURE__*/_react.default.createElement(_heroSlide.CarouselWrapper, {
    ref: ref,
    "data-test": _const.TestType.COMPONENT,
    "data-test-id": _const.TestValue.AEM_HERO_SLIDE_A
  }, /*#__PURE__*/_react.default.createElement(_heroSlide2.HeroSlideStyled, heroSlideProps, /*#__PURE__*/_react.default.createElement(Slide, _extends({}, rest, {
    bgStyles: bgStyles
  })))));
};

var _default = HeroSlideUi;
exports.default = _default;